/* Real Shopify Ajax cart drawer — overrides the legacy demo drawer globally. */
(function(){
  function money(cents){ return usd(cents); }
  /* round amounts read cleaner: $60, not $60.00 */
  function usd(cents){ var v = (cents/100).toFixed(2); return '$' + (/\.00$/.test(v) ? v.slice(0, -3) : v); }
  function els(sel){ return document.querySelectorAll(sel); }

  /* ==================== FREE GIFTS (Grüns-style ladder) ====================
     Config comes from #ezb-gift-cfg (snippets/ezb-cart-drawer.liquid):
     gifts: [{ id, threshold ($), title, value (cents), img, skip: [variant ids] }]
     A gift is a hidden $0 product. It is added automatically once the cart
     (after discounts, excluding gifts) reaches its threshold and removed if
     the cart drops below. Gift lines show in "Your free gifts", not the list. */
  var GC = null;
  try {
    var gcEl = document.getElementById('ezb-gift-cfg');
    if(gcEl) GC = JSON.parse(gcEl.textContent);
  } catch(e){ GC = null; }
  var GIFTS = (GC && GC.gifts ? GC.gifts : []).filter(function(g){ return g && g.id; })
                .sort(function(a,b){ return a.threshold - b.threshold; });
  var GIFT_IDS = {}; GIFTS.forEach(function(g){ GIFT_IDS[String(g.id)] = g; });

  var GDIV = null; /* minor-unit divisor: 100 (USD) or 1000 */
  function giftDivisor(cart){
    if(GDIV) return GDIV;
    if(GC && GC.prices && cart && cart.items){
      for(var i=0;i<cart.items.length;i++){
        var dec = GC.prices[String(cart.items[i].variant_id)];
        if(dec && dec > 0){
          GDIV = (cart.items[i].price / dec) > 500 ? 1000 : 100;
          return GDIV;
        }
      }
    }
    return 100; /* safe default, not cached — retried next render */
  }
  function isGiftLine(it){ return !!GIFT_IDS[String(it.variant_id)]; }
  function giftSubtotal(cart){
    return cart.items.reduce(function(s, it){ return isGiftLine(it) ? s : s + it.final_line_price; }, 0);
  }
  function paidCount(cart){
    return cart.items.reduce(function(s, it){ return (isGiftLine(it) || offerOf(it)) ? s : s + it.quantity; }, 0);
  }
  /* ---- pack offers: free items a pack adds carry hidden _offer properties ---- */
  function offerOf(it){ var p = it.properties || {}; return p._offer ? p : null; }
  function offerBuyQty(cart, vid){
    return cart.items.reduce(function(s, x){ return (String(x.product_id) === String(vid) && !offerOf(x)) ? s + x.quantity : s; }, 0);
  }
  function escHtml(t){ return String(t == null ? '' : t).replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); }
  /* Keeps each free item at 1, and removes it if the pack behind it is broken
     (e.g. the customer drops from 2 bags to 1), so FREE in the cart always
     means free at checkout. */
  var offerBusy = false;
  function offerSync(cart){
    if(offerBusy) return;
    var updates = {}, n = 0;
    cart.items.forEach(function(it){
      var o = offerOf(it); if(!o) return;
      /* _offer_req = "productId:qty,productId:qty" — everything the pack needs */
      var ok = true;
      if(o._offer_req){
        String(o._offer_req).split(',').forEach(function(pair){
          var bits = pair.split(':');
          if(bits.length === 2 && offerBuyQty(cart, bits[0]) < (parseInt(bits[1], 10) || 0)) ok = false;
        });
      } else {
        ok = offerBuyQty(cart, o._offer_buy) >= (parseInt(o._offer_min, 10) || 0);
      }
      var cap = parseInt(o._offer_q, 10) || 1;
      var want = ok ? Math.min(it.quantity, cap) : 0;
      if(it.quantity !== want){ updates[it.key] = want; n++; }
    });
    if(!n) return;
    offerBusy = true;
    fetch('/cart/update.js', {method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ updates: updates })
    }).then(function(r){ return r.json(); })
      .then(function(c){ offerBusy = false; paintAll(c); })
      .catch(function(){ offerBusy = false; });
  }
  function giftEligible(g, cart, sub, div){
    if(sub < g.threshold * div) return false;
    if(g.skip && g.skip.length){
      for(var i=0;i<cart.items.length;i++){
        if(g.skip.indexOf(cart.items[i].variant_id) > -1) return false; /* already bought one */
      }
    }
    return paidCount(cart) > 0;
  }

  /* celebration (confetti + toast) when a gift lands in the cart */
  function confetti(){
    if(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cv=document.getElementById('rcart-confetti');
    if(!cv){ cv=document.createElement('canvas'); cv.id='rcart-confetti';
      cv.style.cssText='position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9998'; document.body.appendChild(cv); }
    var x=cv.getContext('2d'); cv.width=innerWidth; cv.height=innerHeight;
    var C=['#1d5324','#2f7d3f','#e0b34d','#ffffff','#8fd19e'], P=[];
    for(var i=0;i<150;i++) P.push({x:innerWidth*.7+(Math.random()-.5)*220,y:innerHeight*.35,vx:(Math.random()-.5)*12,vy:-(Math.random()*13+6),g:.35+Math.random()*.2,s:5+Math.random()*6,c:C[i%C.length],r:Math.random()*6,vr:(Math.random()-.5)*.4});
    var t0=performance.now();
    (function f(t){ var e=t-t0; x.clearRect(0,0,cv.width,cv.height);
      P.forEach(function(p){ p.vy+=p.g; p.x+=p.vx; p.y+=p.vy; p.r+=p.vr; x.save(); x.globalAlpha=Math.max(0,1-e/1500); x.translate(p.x,p.y); x.rotate(p.r); x.fillStyle=p.c; x.fillRect(-p.s/2,-p.s/2,p.s,p.s*.6); x.restore(); });
      if(e<1500) requestAnimationFrame(f); else x.clearRect(0,0,cv.width,cv.height); })(t0);
  }
  var toastT;
  function toast(html){
    var el=document.getElementById('rcart-toast');
    if(!el){ el=document.createElement('div'); el.id='rcart-toast'; el.setAttribute('role','status'); el.setAttribute('aria-live','polite'); document.body.appendChild(el); }
    el.innerHTML=html; el.classList.add('show'); clearTimeout(toastT); toastT=setTimeout(function(){ el.classList.remove('show'); },2200);
  }

  var giftBusy = false, giftFailed = {};
  function giftSync(cart){
    if(!GIFTS.length || giftBusy) return;
    var div = giftDivisor(cart), sub = giftSubtotal(cart);
    var toAdd = [], updates = {}, changed = false, newly = [];
    GIFTS.forEach(function(g){
      if(giftFailed[g.id]) return;
      var lines = cart.items.filter(function(it){ return String(it.variant_id) === String(g.id); });
      var qty = lines.reduce(function(s,it){ return s + it.quantity; }, 0);
      var ok = giftEligible(g, cart, sub, div);
      if(ok && qty === 0){ toAdd.push({ id: g.id, quantity: 1, properties: { _ezb_gift: 'auto' } }); newly.push(g); }
      if(!ok && qty > 0){ lines.forEach(function(it){ updates[it.key] = 0; }); changed = true; }
      if(ok && qty > 1){ lines.forEach(function(it, i){ updates[it.key] = i === 0 ? 1 : 0; }); changed = true; }
    });
    if(changed){
      giftBusy = true;
      fetch('/cart/update.js', {method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ updates: updates })
      }).then(function(){ giftBusy = false; refresh(false); })
        .catch(function(){ giftBusy = false; });
      return;
    }
    if(toAdd.length){
      giftBusy = true;
      fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items: toAdd })
      }).then(function(r){
        giftBusy = false;
        if(!r.ok){ toAdd.forEach(function(t){ giftFailed[t.id] = true; }); return; } /* unavailable — stop retrying */
        confetti();
        toast('🎁 <b>FREE ' + newly.map(function(g){ return g.title; }).join(' + ') + '</b> unlocked!');
        refresh(false);
      }).catch(function(){ giftBusy = false; });
    }
  }

  /* progress bar at the top of the drawer */
  function paintGiftBar(cart){
    var bar = document.querySelector('[data-rcart-gift]');
    if(!bar || !GIFTS.length) return;
    if(!cart.items.length){ bar.hidden = true; return; }
    bar.hidden = false;
    var div = giftDivisor(cart), sub = giftSubtotal(cart);
    var max = GIFTS[GIFTS.length-1].threshold * div;
    var fill = bar.querySelector('[data-rcart-gift-fill]');
    if(fill) fill.style.width = Math.max(0, Math.min(100, (sub/max)*100)) + '%';
    var marks = bar.querySelector('[data-rcart-gift-marks]');
    if(marks){
      marks.innerHTML = GIFTS.map(function(g){
        var pos = Math.min(100, (g.threshold*div/max)*100), on = sub >= g.threshold*div;
        return '<span class="rg-mark' + (on ? ' on' : '') + '" style="left:' + pos + '%">'
             + '<i>' + (on ? '✓' : '🎁') + '</i><em>$' + g.threshold + '<br>' + String(g.title).split(' ').pop() + '</em></span>';
      }).join('');
    }
    var next = null;
    for(var i=0;i<GIFTS.length;i++){ if(sub < GIFTS[i].threshold*div){ next = GIFTS[i]; break; } }
    var msg = bar.querySelector('[data-rcart-gift-msg]');
    if(next){
      bar.classList.remove('unlocked');
      if(msg) msg.innerHTML = 'Add <b>' + usd((next.threshold*div - sub) * 100 / div) + '</b> more for a <b>FREE ' + next.title + '</b>';
    } else {
      bar.classList.add('unlocked');
      if(msg) msg.innerHTML = '🎉 <b>All free gifts unlocked!</b>';
    }
  }

  /* "Your free gifts" — every gift listed under the cart items, locked or unlocked */
  function paintGifts(cart){
    var box = document.querySelector('[data-rcart-gifts]');
    if(!box || !GIFTS.length) return;
    if(!cart.items.length){ box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    var div = giftDivisor(cart), sub = giftSubtotal(cart);
    var rows = GIFTS.map(function(g){
      var inCart = cart.items.some(function(it){ return String(it.variant_id) === String(g.id); });
      var reached = sub >= g.threshold*div;
      var skipped = reached && !inCart && g.skip && cart.items.some(function(it){ return g.skip.indexOf(it.variant_id) > -1; });
      var state = inCart ? 'on' : (skipped ? 'skip' : 'off');
      var note = inCart ? '✓ Added to your order — free'
               : skipped ? 'You already have one in your cart'
               : '🔒 Add ' + usd((g.threshold*div - sub) * 100 / div) + ' more to unlock';
      return '<div class="rg-row rg-' + state + '">'
        + (g.img ? '<img src="' + g.img + '" alt="" loading="lazy">' : '<span class="rg-img"></span>')
        + '<div class="rg-i"><b>FREE ' + g.title + '</b><small>' + note + '</small></div>'
        + '<span class="rg-v">' + (g.value ? '<s>' + usd(g.value) + '</s>' : '') + '<b>FREE</b></span>'
        + '</div>';
    }).join('');
    box.innerHTML = '<p class="rg-h">🎁 Your free gifts</p>' + rows;
  }
  /* ====================================================================== */

  function updateDots(count){
    els('#cartDot,[data-rcart-count]').forEach(function(d){ d.textContent = count; });
  }

  /* A line the offer makes free shows its value struck through + FREE;
     a discounted line shows the original price struck above the new one. */
  function linePrice(it){
    var orig = it.original_line_price || (it.price * it.quantity);
    if(it.final_line_price === 0 && orig > 0) return '<s class="rcart-was">'+money(orig)+'</s><span class="free">FREE</span>';
    if(it.final_line_price < orig) return '<s class="rcart-was">'+money(orig)+'</s>'+money(it.final_line_price);
    return money(it.final_line_price);
  }

  function hasO2(cart, pid){
    return !!pid && cart.items.some(function(it){ return String(it.product_id) === String(pid); });
  }
  function paintBf(cart){
    var a = document.querySelector('[data-rcart-bf]');
    if(!a || !a.getAttribute('data-o2')) return;
    if(!a.getAttribute('data-kit-href')){
      a.setAttribute('data-kit-href', a.getAttribute('href'));
      var sp0 = a.querySelector('span'); a.setAttribute('data-kit-text', sp0 ? sp0.textContent : '');
    }
    var o2 = hasO2(cart, a.getAttribute('data-o2'));
    a.setAttribute('href', o2 ? a.getAttribute('data-o2-href') : a.getAttribute('data-kit-href'));
    var sp = a.querySelector('span');
    if(sp) sp.textContent = o2 ? a.getAttribute('data-o2-text') : a.getAttribute('data-kit-text');
  }
  /* ---- Original-only ladder in the cart ----
     1 bag  = Single ($20 + $3 delivery)
     2 bags = 2 x "2-Pack Deal" ($30, free delivery)
     3+ bags = Single x q + FREE bottle offer line (buy 2 get 1, $40 for 3)
     ogNormalize keeps the cart on those prices whatever the steppers do. */
  function upCfg(){
    var box = document.querySelector('[data-rcart-kit]');
    if(!box || !box.getAttribute('data-up-single') || !box.getAttribute('data-up-gift')) return null;
    return {box: box, sv: box.getAttribute('data-up-single'), pv: box.getAttribute('data-up-pack') || '',
            gv: box.getAttribute('data-up-gift'), pid: box.getAttribute('data-up-pid')};
  }
  function ogInfo(cart, u){
    var r = {q: 0, singles: 0, packs: 0, bottle: false, lines: []};
    cart.items.forEach(function(it){
      var v = String(it.variant_id), off = offerOf(it);
      if(!off && v === u.sv){ r.q += it.quantity; r.singles += it.quantity; r.lines.push(it); }
      else if(!off && u.pv && v === u.pv){ r.q += it.quantity; r.packs += it.quantity; r.lines.push(it); }
      else if(off && v === u.gv && String(off._offer_req || '').indexOf(u.pid + ':') === 0){ r.bottle = true; r.lines.push(it); }
    });
    return r;
  }
  function ogTarget(info){
    if(info.q === 1) return {singles: 1, packs: 0, bottle: false};
    if(info.q === 2) return {singles: 0, packs: 2, bottle: false};
    if(info.q >= 3) return {singles: info.q, packs: 0, bottle: true};
    return null;
  }
  var ogBusy = false;
  function ogSet(u, q, card){
    if(ogBusy) return Promise.resolve();
    ogBusy = true; if(card) card.classList.add('is-loading');
    var end = function(){ ogBusy = false; if(card) card.classList.remove('is-loading'); };
    return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(cart){
      var info = ogInfo(cart, u), updates = {}, n = 0;
      info.lines.forEach(function(it){ updates[it.key] = 0; n++; });
      var t = ogTarget({q: q}), add = [];
      if(t.singles) add.push({id: parseInt(u.sv, 10), quantity: t.singles});
      if(t.packs) add.push({id: parseInt(u.pv, 10), quantity: t.packs});
      if(t.bottle) add.push({id: parseInt(u.gv, 10), quantity: 1, properties: {_offer: '3 Months Supply', _offer_req: u.pid + ':3', _offer_q: '1'}});
      var clear = n ? fetch('/cart/update.js', {method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({updates: updates})}) : Promise.resolve();
      return clear.then(function(){
        return fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items: add})});
      });
    }).then(function(){ end(); return refresh(!!card); }).catch(function(){ end(); refresh(false); });
  }
  function ogNormalize(cart){
    var u = upCfg(); if(!u || ogBusy || offerBusy || !u.pv) return;
    var info = ogInfo(cart, u), t = ogTarget(info);
    if(!t) return;
    if(info.singles === t.singles && info.packs === t.packs && info.bottle === t.bottle) return;
    /* a 2-bag pack line split oddly, two Singles, or 3+ bags without the bottle: put it right */
    ogSet(u, info.q, null);
  }
  function paintKitUpsell(cart, paidLines){
    var box = document.querySelector('[data-rcart-kit]');
    if(!box) return;
    var min = parseInt(box.getAttribute('data-min'), 10) || 0;
    var total = cart.total_price || 0;
    var o2 = hasO2(cart, box.getAttribute('data-o2'));
    var u = upCfg(), og = u ? ogInfo(cart, u) : {q: 0};
    var hasOffer = cart.items.some(function(it){ return !!offerOf(it); });
    var show;
    if(o2) show = min > 0 && total < min && !hasOffer;
    else if(og.q > 0) show = og.q < 3;
    else show = min > 0 && total < min && !hasOffer;
    show = show && paidLines > 0;
    box.hidden = !show;
    if(!show) return;
    var three = box.querySelector('[data-rcart-kit-main]'), two = box.querySelector('[data-rcart-kit-two]'),
        o2Card = box.querySelector('[data-rcart-kit-o2]'), sub3 = box.querySelector('[data-up-sub3]');
    if(o2Card) o2Card.hidden = !o2;
    if(three) three.hidden = o2;
    if(two) two.hidden = o2 || og.q !== 1;
    var msg = box.querySelector('[data-rcart-kit-msg]'), t;
    if(o2 && o2Card) t = 'You\'re <b>' + usd(min - total) + '</b> away from FREE delivery. Or upgrade:';
    else if(og.q === 1) t = 'Add 1 more bag and get <b>FREE delivery</b>:';
    else if(og.q === 2) t = 'You\'ve got <b>FREE delivery</b>. Make it the 3 Months Supply:';
    else t = 'You\'re <b>' + usd(min - total) + '</b> away from FREE delivery. Or add:';
    if(msg) msg.innerHTML = t;
    if(sub3) sub3.textContent = og.q === 2
      ? 'Add a 3rd bag for $10 more: buy 2, get 1 FREE + a FREE Energyze bottle.'
      : 'Buy 2, get 1 FREE + a FREE Energyze bottle and FREE delivery.';
  }
  document.addEventListener('click', function(e){
    var card = e.target.closest ? e.target.closest('[data-rcart-kit-main],[data-rcart-kit-two]') : null;
    if(!card) return;
    var u = upCfg(); if(!u) return;
    var q = parseInt(card.getAttribute('data-up-q'), 10) || 3;
    if(q === 2 && !u.pv) return;
    e.preventDefault();
    ogSet(u, q, card);
  });

  function render(cart){
    var host = document.querySelector('[data-rcart-items]');
    if(!host) return;
    updateDots(paidCount(cart));
    var sub = document.querySelector('[data-rcart-subtotal]');
    if(sub) sub.textContent = money(cart.items_subtotal_price);
    var paid = [];
    cart.items.forEach(function(it, i){ if(!isGiftLine(it)) paid.push({it: it, line: i + 1}); });
    paintKitUpsell(cart, paid.length);
    paintBf(cart);
    if(!paid.length){
      host.innerHTML = '<div class="rcart-empty"><b>Your cart is empty.</b><br><small>Your ritual starts with one scoop.</small></div>';
      return;
    }
    var saveEl = document.querySelector('[data-rcart-save]');
    if(saveEl){
      var saved = cart.items.reduce(function(s, it){
        var orig = it.original_line_price || (it.price * it.quantity);
        return s + (offerOf(it) ? orig : Math.max(0, orig - it.final_line_price));
      }, 0);
      var b = saveEl.querySelector('b');
      if(b) b.textContent = money(saved);
      saveEl.hidden = !(saved > 0);
    }
    /* Kit name for free lines that come from an automatic discount (the 3rd
       Original / 3rd Super Green of the 90-Day Supply carry no offer tag). */
    var kitName = '';
    cart.items.forEach(function(it){ var oo = offerOf(it); if(oo && oo._offer && !kitName) kitName = oo._offer; });
    host.innerHTML = paid.map(function(p){
      var it = p.it;
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      /* two-option products (Offer 2: Flavor / Pack) show just the flavor */
      if(vt && it.options_with_values && it.options_with_values.length > 1) vt = it.options_with_values[0].value;
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_120x$1$2') : '';
      var o = offerOf(it);
      var orig = it.original_line_price || (it.price * it.quantity);
      if(!o && it.final_line_price === 0 && orig > 0) o = {_offer: kitName || 'kit'};
      if(o){
        return '<div class="rcart-line rcart-line--offer">'
          + (img ? '<img src="'+img+'" alt="">' : '<span style="width:60px;height:60px;border-radius:10px;background:var(--cream)"></span>')
          + '<div class="rcart-info"><b>'+it.product_title+'</b>'
          + (vt ? '<span class="rcart-flav">Flavor: <b>'+vt+'</b></span>' : '')
          + '<span class="rcart-offer-tag">FREE GIFT</span><small class="rcart-offer-src">With your '+escHtml(o._offer)+'</small>'
          + '</div>'
          + '<span class="rcart-price">'+(it.quantity > 1 ? '<small class="rcart-offer-qty">&times;'+it.quantity+'</small>' : '')+'<s class="rcart-was">'+money(it.original_line_price || (it.price * it.quantity))+'</s><span class="free">FREE</span></span>'
          + '</div>';
      }
      return '<div class="rcart-line">'
        + (img ? '<img src="'+img+'" alt="">' : '<span style="width:60px;height:60px;border-radius:10px;background:var(--cream)"></span>')
        + '<div class="rcart-info"><b>'+it.product_title+'</b>'
        + (vt ? '<span class="rcart-flav">Choose your flavor: <b>'+vt+'</b></span>' : '')
        + '<span class="rcart-qty">'
        + '<button type="button" aria-label="Decrease" onclick="rcartQty('+p.line+','+(it.quantity-1)+')">−</button>'
        + '<span>'+it.quantity+'</span>'
        + '<button type="button" aria-label="Increase" onclick="rcartQty('+p.line+','+(it.quantity+1)+')">+</button>'
        + '</span>'
        + '<button class="rcart-rm" type="button" onclick="rcartQty('+p.line+',0)">Remove</button>'
        + '</div>'
        + '<span class="rcart-price">'+linePrice(it)+'</span>'
        + '</div>';
    }).join('');
  }

  /* ---- cross-sell: show products that are NOT already in the cart ---- */
  var CATALOGUE = null;
  function catalogue(){
    if(CATALOGUE) return CATALOGUE;
    var el = document.querySelector('[data-rcart-catalogue]');
    try { CATALOGUE = JSON.parse(el.textContent); } catch(e){ CATALOGUE = []; }
    return CATALOGUE;
  }
  function renderXsell(cart){
    var box = document.querySelector('[data-rcart-xs]');
    var track = document.querySelector('[data-rcart-xs-track]');
    if(!box || !track) return;
    var inCart = {};
    cart.items.forEach(function(i){ inCart[i.product_id] = true; });
    var recs = catalogue().filter(function(p){ return !inCart[p.pid]; });
    if(!paidCount(cart) || !recs.length){ box.hidden = true; track.innerHTML = ''; return; }
    box.hidden = false;
    track.innerHTML = recs.map(function(p){
      return '<div class="rcart-xs-card">'
        + (p.img ? '<img src="'+p.img+'" alt="" loading="lazy">' : '<span class="rcart-xs-img"></span>')
        + '<span class="rcart-xs-i"><b>'+p.title+'</b><span>'+p.price+'</span></span>'
        + '<button class="rcart-xs-add" type="button" aria-label="Add ' + p.title.replace(/"/g,'') + '" '
        + 'onclick="rcartAdd('+p.id+',this)">'
        + '<svg class="xs-plus" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5.5v13M5.5 12h13"/></svg>'
        + '<svg class="xs-dots" viewBox="0 0 24 24" aria-hidden="true"><circle cx="5.5" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="18.5" cy="12" r="1.5"/></svg>'
        + '</button>'
        + '</div>';
    }).join('');
  }
  window.rcartAdd = function(variantId, btn){
    if(btn){ btn.disabled = true; btn.classList.add('is-loading'); }
    fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: variantId, quantity: 1}]})
    }).then(function(r){
      if(!r.ok) throw 0;
      return refresh(true);
    }).then(function(){
      if(btn){ btn.disabled = false; btn.classList.remove('is-loading'); }
    }).catch(function(){
      if(btn){ btn.disabled = false; btn.classList.remove('is-loading'); }
    });
  };

  function paintAll(cart){
    render(cart);
    renderXsell(cart);
    paintGiftBar(cart);
    paintGifts(cart);
    giftSync(cart);
    offerSync(cart);
    ogNormalize(cart);
  }

  function refresh(open){
    return fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        paintAll(cart);
        if(open){ document.body.classList.add('rcart-open'); }
        return cart;
      });
  }

  /* `line` is the 1-based position in the real cart (gift lines included) */
  window.rcartQty = function(line, qty){
    fetch('/cart/change.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function(r){ return r.json(); }).then(function(c){ paintAll(c); })
      .catch(function(){ refresh(false); });
  };

  /* Global overrides: every openCart()/closeCart() in the theme now drives the real drawer */
  window.openCart = function(){ refresh(true); };
  window.closeCart = function(){ document.body.classList.remove('rcart-open'); };
  /* called by add-to-cart flows after a successful /cart/add.js */
  window.ezbCartAdded = function(){ refresh(true); };

  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') window.closeCart(); });
  /* initial badge sync */
  if(document.readyState !== 'loading') refresh(false);
  else document.addEventListener('DOMContentLoaded', function(){ refresh(false); });
})();
